import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CAMPAIN_GET } from "../../../API/campainApi";
import { MEDIA_GET, MEDIA_GET_PAGE, MEDIA_SEARCH } from "../../../API/mediaApi";
import { Card } from "../../../components/Card";
import { SideMenu } from "../../../components/SideMenu";
import Pagination from "react-js-pagination";
import { Panel } from "primereact/panel";
import "./styles.scss";

export function CampainMedia() {
  const { id } = useParams();
  const token = window.localStorage.getItem("token");

  const [loading, setLoading] = useState(null);
  const [error, setError] = useState(null);

  const [pagination, setPagination] = useState(null);
  const [campain, setCampain] = useState(null);
  const [media, setMedia] = useState();
  const [mediaSearch, setMediaSearch] = useState({
    participation: "",
    approved: 0,
    identification: "",
  });

  useEffect(() => {
    async function getCampain() {
      setLoading(true);
      const { url, options } = CAMPAIN_GET(id, token);

      try {
        const campainResponse = await fetch(url, options);
        const campainJson = await campainResponse.json();

        setCampain(campainJson.data);
      } catch (err) {
        console.log(err.message);
      } finally {
        setLoading(false);
      }
    }

    getCampain();
  }, [id, token]);

  async function getMedia() {
    setLoading(true);

    const { url, options } = MEDIA_GET(id, token);

    try {
      const mediaResponse = await fetch(url, options);
      const mediaJson = await mediaResponse.json();

      if (mediaJson.data.data.length === 0) {
        setError("Não há midias nesta campanha ainda. Tente mais tarde.");
      }

      setMedia(mediaJson.data.data);

      console.log(mediaJson.data.data);
      setPagination(mediaJson.data);
    } catch (err) {
      console.log(err.message);
    } finally {
      setLoading(false);
    }
  }

  async function getMediaPage(pageNumber) {
    const { url, options } = MEDIA_GET_PAGE(id, token, pageNumber);
    setLoading(true);

    const mediaResponse = await fetch(url, options);
    const mediaJson = await mediaResponse.json();

    setPagination(mediaJson.data);
    setMedia(mediaJson.data.data);

    setLoading(false);

    window.scrollTo(0, 0)
  }

  useEffect(() => {
    getMedia();
  }, []);

  function handleChange({ target }) {
    const { id, value } = target;
    setMediaSearch({ ...mediaSearch, [id]: value });
    console.log(mediaSearch);
  }

  async function handleSubmit(event) {
    event.preventDefault();

    setLoading(true);

    if (mediaSearch.identification === "" && mediaSearch.participation === "") {
      let { url, options } = MEDIA_SEARCH(id, token, {
        approved: Number(mediaSearch.approved),
      });

      try {
        const searchResponse = await fetch(url, options);
        const searchJson = await searchResponse.json();

        if (searchJson.data.data.length === 0) {
          setError(
            "Não houve resultados para a sua busca. Tente com outros dados."
          );
        }

        setMedia(searchJson.data.data);
      } catch (err) {
        setError("Não foi possivel fazer a busca. Tente com outros dados.");
      } finally {
        setLoading(false);
      }
    } else if (mediaSearch.identification === "") {
      let { url, options } = MEDIA_SEARCH(id, token, {
        participation: mediaSearch.participation,
        approved: Number(mediaSearch.approved),
      });

      try {
        const searchResponse = await fetch(url, options);
        const searchJson = await searchResponse.json();

        if (searchJson.data.data.length === 0) {
          setError(
            "Não houve resultados para a sua busca. Tente com outros dados."
          );
        }

        setMedia(searchJson.data.data);
      } catch (err) {
        console.log("teste");
        setError("Não foi possivel fazer a busca. Tente com outros dados.");
      } finally {
        setLoading(false);
      }
    } else if (mediaSearch.participation === "") {
      let { url, options } = MEDIA_SEARCH(id, token, {
        identification: mediaSearch.identification,
        approved: Number(mediaSearch.approved),
      });

      try {
        const searchResponse = await fetch(url, options);
        const searchJson = await searchResponse.json();

        if (searchJson.data.data.length === 0) {
          setError(
            "Não houve resultados para a sua busca. Tente com outros dados."
          );
        }

        setMedia(searchJson.data.data);
      } catch (err) {
        setError("Não foi possivel fazer a busca. Tente com outros dados.");
        console.log("teste");
      } finally {
        setLoading(false);
      }
    } else {
      let { url, options } = MEDIA_SEARCH(id, token, {
        identification: mediaSearch.identification,
        participation: mediaSearch.participation,
        approved: Number(mediaSearch.approved),
      });

      try {
        const searchResponse = await fetch(url, options);
        const searchJson = await searchResponse.json();

        if (searchJson.data.data.length === 0) {
          setError(
            "Não houve resultados para a sua busca. Tente com outros dados."
          );
        }

        setMedia(searchJson.data.data);
      } catch (err) {
        setError("Não foi possivel fazer a busca. Tente com outros dados.");
        console.log("teste");
      } finally {
        setLoading(false);
      }
    }
  }

  return (
    <div>
      <div>
        <SideMenu />
      </div>

      <div className="container fadeIn">
        <div className="row">
          <div className="col-md-12">
            <div className="headerCampain">
              <div>
                <h1>{campain == null ? "Nome Campanha" : campain[0].name}</h1>
                <span>
                  Você pode aprovar ou reprovar as midias. Divirta-se!
                </span>
              </div>
            </div>
          </div>

          <div className="col-md-12">
            <Panel header="Filtros" className="filter" toggleable>
              <form className="row formFilter" onSubmit={handleSubmit}>
                <div className="col-md-3 searchInput">
                  <input
                    id="identification"
                    value={mediaSearch.identification}
                    onChange={handleChange}
                    className="form-control"
                    type="text"
                    placeholder="Digite uma Identificação.."
                  />
                </div>

                <div className="col-md-3">
                  <select
                    id="approved"
                    value={mediaSearch.approved}
                    className="form-control searchInput"
                    onChange={handleChange}
                  >
                    <option value={0}>Pendente</option>
                    <option value={1}>Aprovado</option>
                    <option value={2}>Reprovado</option>
                  </select>
                </div>

                <div className="col-md-3">
                  <input
                    id="participation"
                    value={mediaSearch.participation}
                    onChange={handleChange}
                    className="form-control searchInput"
                    type="date"
                  />
                </div>

                <div className="col-md-3 searchInput">
                  {loading ? (
                    <button>Buscando... </button>
                  ) : (
                    <button>Buscar </button>
                  )}
                </div>
              </form>
            </Panel>
          </div>
        </div>

        <div className="row">
          {media === undefined ? (
            <h4 className="col-md-12">Carregando...</h4>
          ) : (
            media.map((item) => {
              return (
                <Card
                  key={item.id}
                  active={item.active}
                  approved={item.approved}
                  campain_name={item.campain_name}
                  cpf={item.cpf}
                  fk_id_media_type={item.fk_id_media_type}
                  id={item.id}
                  participation={item.participation}
                  phone={item.phone}
                  url={item.url}
                  file={item.file}
                  loading={loading}
                  getMedia={getMediaPage}
                  setLoading={setLoading}
                />
              );
            })
          )}

          {media
            ? media.length <= 0 && (
                <h4 className="col-md-12 mt-2 text-danger">{error}</h4>
              )
            : ""}

          <div className="col-md-12 mb-5">
            {loading === true && pagination === null ? (
              ""
            ) : (
              <Pagination
                totalItemsCount={pagination && pagination.total}
                activePage={pagination && pagination.current_page}
                onChange={(pageNumber) => getMediaPage(pageNumber)}
                itemsCountPerPage={pagination && pagination.per_page}
                itemClass="page-item"
                firstPageText="Primeira"
                lastPageText="Ultima"
                hideDisabled
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
